import WeaponType from "../enums/WeaponType";

const WEAPONS = {
  [WeaponType.HASHBLADE]: [
    {
      level: 1,
      bulletType: WeaponType.HASHBLADE,
      nameKey: "weapons.hashblade.name",
      frameName: "hashblade",
      iconName: "hashblade_icon",
      animationKey: "hashblade_attack",
      descriptionKey: "weapons.hashblade.description",
      tipsKey: "weapons.hashblade.tips",
      isUnlocked: true,
      rarity: 100,
      // The smaller the value, the faster
      interval: 1350,
      repeatInterval: 100,
      power: 1,
      area: 1,
      speed: 1,
      amount: 2,
      hitsWalls: false,
    },
    {
      amount: 1,
    },
    {
      power: 0.2,
    },
    {
      power: 0.3,
      area: 0.1,
    },
    {
      power: 0.5,
    },
    {
      power: 0.5,
      area: 0.1,
    },
    {
      power: 0.5,
    },
    {
      power: 0.5,
    },
  ],
  [WeaponType.BLAST]: [
    {
      level: 1,
      bulletType: WeaponType.BLAST,
      nameKey: "weapons.blast.name",
      frameName: "blast",
      iconName: "blast_icon",
      animationKey: "blast_attack",
      descriptionKey: "weapons.blast.description",
      tipsKey: "weapons.blast.tips",
      isUnlocked: true,
      rarity: 100,
      interval: 2500,
      repeatInterval: 100,
      power: 0.3,
      area: 2,
      speed: 1,
      amount: 1,
      hitsWalls: false,
    },
    {
      area: 0.1,
      interval: -200,
    },
    {
      interval: -300,
    },
    {
      interval: -400,
    },
    {
      area: 0.1,
    },
    {
      power: 0.2,
      area: 0.1,
    },
    {
      area: 0.2,
    },
    {
      power: 0.4,
      interval: -400,
    },
  ],
  [WeaponType.BOOMERANG]: [
    {
      level: 1,
      bulletType: WeaponType.BOOMERANG,
      nameKey: "weapons.boomerang.name",
      descriptionKey: "weapons.boomerang.description",
      tipsKey: "weapons.boomerang.tips",
      frameName: "boomerang",
      iconName: "boomerang",
      animationKey: null,
      isUnlocked: true,
      rarity: 100,
      interval: 3000,
      repeatInterval: 0,
      power: 0.3,
      area: 1,
      speed: 1,
      amount: 2,
      duration: 2000,
    },
    {
      duration: 200,
      area: 0.2,
    },
    {
      power: 0.5,
      amount: 1,
    },
    {
      speed: 0.5,
      area: 0.2,
    },
    {
      power: 0.5,
      amount: 1,
    },
    {
      duration: 200,
      area: 0.2,
    },
    {
      power: 1,
      amount: 1,
    },
    {
      duration: 200,
      speed: 0.5,
    },
  ],
  [WeaponType.MAGNET]: [
    {
      level: 1,
      bulletType: WeaponType.MAGNET,
      nameKey: "weapons.magnet.name",
      descriptionKey: "weapons.magnet.description",
      frameName: "magnet",
      iconName: "magnet",
      isUnlocked: true,
      rarity: 100,
      isPowerUp: true,
      magnet: 0.5,
    },
    {
      magnet: 0.33,
    },
    {
      magnet: 0.25,
    },
    {
      magnet: 0.2,
    },
    {
      magnet: 0.33,
    },
  ],
  [WeaponType.POWER]: [
    {
      level: 1,
      bulletType: WeaponType.POWER,
      nameKey: "weapons.power.name",
      descriptionKey: "weapons.power.description",
      frameName: "power",
      iconName: "power",
      isUnlocked: true,
      rarity: 100,
      isPowerUp: true,
      power: 0.1,
    },
    {
      power: 0.1,
    },
    {
      power: 0.1,
    },
    {
      power: 0.1,
    },
    {
      power: 0.1,
    },
  ],
  [WeaponType.FORK]: [
    {
      level: 1,
      bulletType: WeaponType.FORK,
      nameKey: "weapons.fork.name",
      descriptionKey: "weapons.fork.description",
      frameName: "fork",
      iconName: "fork",
      isUnlocked: true,
      rarity: 50,
      isPowerUp: true,
      amount: 1,
    },
    {
      amount: 1,
    },
  ],
  [WeaponType.RANGE]: [
    {
      level: 1,
      bulletType: WeaponType.RANGE,
      nameKey: "weapons.range.name",
      descriptionKey: "weapons.range.description",
      frameName: "range",
      iconName: "range",
      isUnlocked: true,
      rarity: 100,
      isPowerUp: true,
      area: 0.1,
    },
    {
      area: 0.1,
    },
    {
      area: 0.1,
    },
    {
      area: 0.1,
    },
    {
      area: 0.1,
    },
  ],
  [WeaponType.COOLDOWN]: [
    {
      level: 1,
      bulletType: WeaponType.COOLDOWN,
      nameKey: "weapons.cooldown.name",
      descriptionKey: "weapons.cooldown.description",
      frameName: "cooldown",
      iconName: "cooldown",
      isUnlocked: true,
      rarity: 50,
      isPowerUp: true,
      cooldown: -0.08,
    },
    {
      cooldown: -0.08,
    },
    {
      cooldown: -0.08,
    },
    {
      cooldown: -0.08,
    },
    {
      cooldown: -0.08,
    },
  ],
  [WeaponType.SPEED]: [
    {
      level: 1,
      bulletType: WeaponType.SPEED,
      nameKey: "weapons.speed.name",
      descriptionKey: "weapons.speed.description",
      frameName: "speed",
      iconName: "speed",
      isUnlocked: true,
      rarity: 100,
      isPowerUp: true,
      speed: 0.1,
    },
    {
      speed: 0.1,
    },
    {
      speed: 0.1,
    },
    {
      speed: 0.1,
    },
    {
      speed: 0.1,
    },
  ],
  [WeaponType.DURATION]: [
    {
      level: 1,
      bulletType: WeaponType.DURATION,
      nameKey: "weapons.duration.name",
      descriptionKey: "weapons.duration.description",
      frameName: "duration",
      iconName: "duration",
      isUnlocked: true,
      rarity: 100,
      isPowerUp: true,
      duration: 0.1,
    },
    {
      duration: 0.1,
    },
    {
      duration: 0.1,
    },
    {
      duration: 0.1,
    },
    {
      duration: 0.1,
    },
  ],
  [WeaponType.ARMOR]: [
    {
      level: 1,
      bulletType: WeaponType.ARMOR,
      nameKey: "weapons.armor.name",
      descriptionKey: "weapons.armor.description",
      frameName: "armor",
      iconName: "armor",
      isUnlocked: true,
      rarity: 100,
      isPowerUp: true,
      armor: 1,
    },
    {
      armor: 1,
    },
    {
      armor: 1,
    },
    {
      armor: 1,
    },
    {
      armor: 1,
    },
  ],
  [WeaponType.MAXHEALTH]: [
    {
      level: 1,
      bulletType: WeaponType.MAXHEALTH,
      nameKey: "weapons.maxhealth.name",
      descriptionKey: "weapons.maxhealth.description",
      frameName: "maxhealth",
      iconName: "maxhealth",
      isUnlocked: true,
      rarity: 100,
      isPowerUp: true,
      maxHp: 0.1,
    },
    {
      maxHp: 0.1,
    },
    {
      maxHp: 0.1,
    },
    {
      maxHp: 0.1,
    },
    {
      maxHp: 0.1,
    },
  ],
  [WeaponType.GROWTH]: [
    {
      level: 1,
      bulletType: WeaponType.GROWTH,
      nameKey: "weapons.growth.name",
      descriptionKey: "weapons.growth.description",
      frameName: "growth",
      iconName: "growth",
      rarity: 80,
      isPowerUp: true,
      growth: 0.07,
    },
    {
      growth: 0.07,
    },
    {
      growth: 0.07,
    },
    {
      growth: 0.07,
    },
    {
      growth: 0.07,
    },
  ],
  [WeaponType.MOVESPEED]: [
    {
      level: 1,
      bulletType: WeaponType.MOVESPEED,
      nameKey: "weapons.movespeed.name",
      descriptionKey: "weapons.movespeed.description",
      frameName: "movespeed",
      iconName: "movespeed",
      isUnlocked: true,
      rarity: 50,
      isPowerUp: true,
      moveSpeed: 0.1,
    },
    {
      moveSpeed: 0.1,
    },
    {
      moveSpeed: 0.1,
    },
    {
      moveSpeed: 0.1,
    },
    {
      moveSpeed: 0.1,
    },
  ],
  [WeaponType.LUCK]: [
    {
      level: 1,
      bulletType: WeaponType.LUCK,
      nameKey: "weapons.luck.name",
      descriptionKey: "weapons.luck.description",
      frameName: "luck",
      iconName: "luck",
      isUnlocked: true,
      rarity: 100,
      isPowerUp: true,
      luck: 0.1,
    },
    {
      luck: 0.1,
    },
    {
      luck: 0.1,
    },
    {
      luck: 0.1,
    },
    {
      luck: 0.1,
    },
  ],
  [WeaponType.ROCK]: [
    {
      level: 1,
      bulletType: WeaponType.ROCK,
      nameKey: "weapons.rock.name",
      descriptionKey: "weapons.rock.description",
      tipsKey: "weapons.rock.tips",
      frameName: "rock",
      iconName: "rock",
      isUnlocked: true,
      rarity: 100,
      interval: 4000,
      repeatInterval: 200,
      power: 2,
      area: 1,
      speed: 1,
      amount: 1,
      penetrating: 2,
      duration: 2000,
    },
    {
      amount: 1,
    },
    {
      power: 2,
    },
    {
      penetrating: 2,
    },
    {
      amount: 1,
    },
    {
      power: 2,
    },
    {
      penetrating: 2,
    },
  ],
  [WeaponType.BUBBLE]: [
    {
      level: 1,
      bulletType: WeaponType.BUBBLE,
      nameKey: "weapons.bubble.name",
      descriptionKey: "weapons.bubble.description",
      tipsKey: "weapons.bubble.tips",
      frameName: "bubble",
      iconName: "bubble",
      isUnlocked: true,
      rarity: 70,
      interval: 1000,
      repeatInterval: 0,
      power: 0.2,
      area: 1,
      speed: 1,
      amount: 1,
      knockback: 0,
    },
    {
      area: 0.3,
      power: 0.1,
    },
    {
      interval: -100,
      power: 0.1,
    },
    {
      area: 0.2,
      power: 0.1,
    },
    {
      interval: -100,
      power: 0.2,
    },
    {
      area: 0.2,
      power: 0.1,
    },
    {
      interval: -100,
      power: 0.1,
    },
    {
      area: 0.2,
      power: 0.2,
    },
  ],
  [WeaponType.STONEAURA]: [
    {
      level: 1,
      bulletType: WeaponType.STONEAURA,
      nameKey: "weapons.stoneaura.name",
      descriptionKey: "weapons.stoneaura.description",
      tipsKey: "weapons.stoneaura.tips",
      frameName: "rock", // Reusing rock frame for now
      iconName: "stoneaura_icon", // Will need to create this asset
      isUnlocked: false,
      isEvolution: true,
      evolvesFrom: [WeaponType.ROCK, WeaponType.COOLDOWN],
      rarity: 100,
      interval: 200, // Fast interval for aura effect
      repeatInterval: 0,
      power: 2, // Similar to maxed stone weapon
      area: 1.5,
      speed: 1,
      amount: 3, // Start with 3 stones
      penetrating: 3,
      duration: 1000,
      cooldown: -0.4,
    },
    {
      amount: 1,
    },
    {
      amount: 1,
    },
    {
      amount: 1,
    },
    {
      amount: 1,
    },
  ],
};

export default WEAPONS;
